import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
import set from 'lodash/set';
import 'mapbox-gl/dist/mapbox-gl.css';
export default {
  name: 'NiotaClassicDevicesEditForm',
  mixins: [formMixin],
  props: {
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    applications: {
      type: Array,
      required: false,
      default: new Array()
    },
    datasourceType: {
      type: String,
      required: false,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      extraFields: [{
        name: '',
        value: '',
        icon: ''
      }],
      addressObject: {
        address: '',
        coordinates: [null, null]
      },
      isActility: false,
      adrLimits: [{
        id: '0',
        title: 'SF 12 / BW 125 MHz'
      }, {
        id: '1',
        title: 'SF 11 / BW 125 MHz'
      }, {
        id: '2',
        title: 'SF 10 / BW 125 MHz'
      }, {
        id: '3',
        title: 'SF 9 / BW 125 MHz'
      }, {
        id: '4',
        title: 'SF 8 / BW 125 MHz'
      }, {
        id: '5',
        title: 'SF 7 / BW 125 MHz'
      }, {
        id: '6',
        title: 'SF 7 / BW 250 MHz'
      }]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    buttons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'submit',
        valid: this.isIotHubManager
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    coordinateLookup() {
      return get(this.formItem, 'properties.coordinateMode') !== 'manual';
    }
  },
  watch: {},
  created() {
    this.formItem = cloneDeep(this.editedItem);
    if (get(this.formItem, 'properties.extraFields') && get(this.formItem, 'properties.extraFields').length) {
      this.extraFields = get(this.formItem, 'properties.extraFields');
    }
    this.setAddressObject();
    if (this.datasourceType === 'actility' || this.datasourceType === 'ACTILITY') {
      this.isActility = true;
    }
  },
  methods: {
    revalidateForm() {
      this.$refs && this.$refs.form ? this.$refs.form.validate() : null;
    },
    validateDeviceProperties(index, value) {
      const fields = this.extraFields[index] || {};
      const totalLength = [fields.icon || '', fields.name || '', fields.value || ''].join('').length;
      return Boolean(totalLength && value || !totalLength && !value);
    },
    filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    tagsChanged(tags) {
      this.formItem.tags = tags;
    },
    addKeyValuePair() {
      this.extraFields = cloneDeep(this.extraFields.concat([{
        name: '',
        value: '',
        icon: ''
      }]));
    },
    removeKeyValuePair(index) {
      pullAt(this.extraFields, [index]);
      if (this.extraFields.length === 0) {
        this.addKeyValuePair();
      }
      // trigger a UI refresh
      this.extraFields = cloneDeep(this.extraFields);
    },
    updateFormData(item, value) {
      set(this.formItem, item, value);
    },
    update() {
      if (this.extraFields[0].name && this.extraFields[0].value) {
        if (this.formItem.properties) {
          this.formItem.properties['extraFields'] = this.extraFields;
        } else {
          this.formItem.properties = {};
          this.formItem.properties['extraFields'] = this.extraFields;
        }
      }
      this.updateDevice();
    },
    updateDevice() {
      NiotaClassicApiService.deviceUpdate(this.formItem.id, this.formItem).then(res => {
        if (!res.data.err) {
          this.formItem = res.data.device;
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.updateSuccessful'), 'success');
          this.$emit('refreshList');
          this.$emit('close');
        } else {
          this.$snack(res.data.err, 'error');
        }
      }).catch(error => {
        if (get(error, 'response.data.err')) {
          this.$snack(get(error, 'response.data.err'), 'error');
        } else {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.updateFailed'), 'error');
        }
      });
    },
    setAddressObject() {
      if (!isNaN(this.formItem.lon) && !isNaN(this.formItem.lat)) {
        this.addressObject = {
          address: this.formItem.deviceAddress,
          coordinates: [this.formItem.lon || null, this.formItem.lat || null]
        };
      }
    },
    addressSelected(addressData) {
      this.formItem.deviceAddress = addressData.address;
      [this.formItem.lon, this.formItem.lat] = addressData.coordinates;
      this.formItem.properties = {
        ...(this.formItem.properties || {}),
        coordinateMode: addressData.pickedManualCoordinates ? 'manual' : 'auto'
      };
    },
    showPrompt() {
      this.deletePrompt = true;
    }
  }
};